import { render, staticRenderFns } from "./TaskTeams.vue?vue&type=template&id=8fcd6132&scoped=true&"
import script from "./TaskTeams.vue?vue&type=script&lang=js&"
export * from "./TaskTeams.vue?vue&type=script&lang=js&"
import style0 from "./TaskTeams.vue?vue&type=style&index=0&id=8fcd6132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcd6132",
  null
  
)

export default component.exports